@if (loaderService.isLoading()) {
  <div class="loader">
    <div class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>
  </div>
}
